import Typography from '@mui/material/Typography';
import { renderColor } from '../../../core/utils';

const TextCustom = ({
  text = '',
  isParagraph = false,
  variant = '',
  isWrap = false,
  component = '',
  className = '',
  color = 'texto',
  colorHexa = '',
  required = false,
}) => {
  return (
    <Typography
      paragraph={isParagraph}
      noWrap={isWrap}
      variant={variant}
      component={component}
      className={className ? className : `fontPRegular`}
      style={{
        color: colorHexa ? colorHexa : renderColor(color),
      }}
    >
      {text} {required && <span className="text-[#DD2254]">*</span>}
    </Typography>
  );
};

export default TextCustom;
